import type { RouteObject } from "react-router-dom";
import { BillDetailPage } from "./BillDetail";
import { BillingPage } from "./BillingPage";
import { CounterPage } from "./Counter";
import { InvoicePage } from "./InvoicePage";

/** `/billing/new` and the detail routes are listed before nothing else matches them; static before `:id`. */
export const routes: RouteObject[] = [
  { path: "billing", element: <BillingPage /> },
  { path: "billing/new", element: <CounterPage /> },
  { path: "billing/bills/:id", element: <BillDetailPage /> },
  { path: "billing/invoices/:id", element: <InvoicePage /> },
  { path: "billing/credit-notes/:id", element: <InvoicePage creditNote /> },
];
